export type PageItem = number | 'ellipsis-start' | 'ellipsis-end'

/**
 * Page numbers to render: first, last, current plus or minus `siblings`, with ellipses for gaps.
 * A gap of a single page shows that page instead of an ellipsis.
 */
export function paginationRange(current: number, pageCount: number, siblings = 1): PageItem[] {
  if (pageCount <= 0) return []
  const page = Math.min(Math.max(1, current), pageCount)
  const start = Math.max(2, page - siblings)
  const end = Math.min(pageCount - 1, page + siblings)
  const items: PageItem[] = [1]
  if (start > 3) items.push('ellipsis-start')
  else if (start === 3) items.push(2)
  for (let p = start; p <= end; p++) items.push(p)
  if (end < pageCount - 2) items.push('ellipsis-end')
  else if (end === pageCount - 2) items.push(pageCount - 1)
  if (pageCount > 1) items.push(pageCount)
  return items
}

/** "1 to 30 of 2,314" (empty string when there are no items). */
export function paginationSummary(page: number, pageSize: number, total: number): string {
  if (total <= 0) return ''
  const start = (page - 1) * pageSize + 1
  const end = Math.min(page * pageSize, total)
  const fmt = (n: number) => n.toLocaleString('en-US')
  return `${fmt(start)} to ${fmt(end)} of ${fmt(total)}`
}
